
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { setPay, setInviteLogin } from '@/api/gcash/account'
import { getBnakList } from '@/api/universal'
import { getProductList } from '@/api/product/product'

@Component({
  name: 'onePay',
  components: {},
})
export default class extends Vue {
  @Prop({ required: true }) info!: any

  private loading: boolean = false
  private google_code: any = ''
  // pay_bank
  private payBankForm: any = {
    bank_name: '',
    bank_code: '',
    dst_accno: '',
    dst_accname: '',
    amount: '',
    msisdn: '',
  }

  private rules: any = {
    to_gcash: [
      {
        required: true,
        message: 'Please enter transfer to account',
        trigger: 'blur',
      },
    ],
    amount: [
      {
        required: true,
        message: 'Please enter the amount transferred',
        trigger: 'blur',
      },
    ],
    remark: [
      { required: true, message: 'Please enter remarks', trigger: 'blur' },
    ],
    to_msisdn: [
      { required: true, message: 'Please enter to phone', trigger: 'blur' },
    ],
    bank_name: [
      { required: true, message: 'Please select bank name', trigger: 'change' },
    ],
    bank_code: [
      { required: true, message: 'Please enter bank code', trigger: 'blur' },
    ],
    dst_accno: [
      {
        required: true,
        message: 'Please enter bank accounts',
        trigger: 'blur',
      },
    ],
    dst_accname: [
      { required: true, message: 'Please enter holder name', trigger: 'blur' },
    ],
  }

  // 获取Gcash产品明细
  private bankList: any = []
  private async getList() {
    try {
      await setInviteLogin({
        action: 'product_bank',
        data: {
          code: 'GCash',
        },
      }).then((res: any) => {
        this.bankList = res.data
      })
    } catch (e) {}
  }

  private changeBank(val: any) {
    let bankCode = this.bankList.filter((item) => {
      return item.bank_name === val
    })
    this.payBankForm.bank_code = bankCode[0].bank_code
  }

  private change() {
    this.google_code = ''
    // this.payBankForm.amount = this.info.remain_money
    this.payBankForm.msisdn = this.info.phone_number
  }

  private back() {
    this.payBankForm = {
      bank_name: '',
      bank_code: '',
      dst_accno: '',
      dst_accname: '',
      amount: '',
      msisdn: '',
    }
    this.google_code = ''
    this.$emit('close')
  }

  public flag: boolean = false
  // 按钮只触发一次
  public flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 1000)
  }

  private async payBank() {
    ;(this.$refs.payBankForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.flag = true
          let data: any = {
            action: 'bank_transfer',
            data: {
              ...this.payBankForm,
              google_code: this.google_code,
            },
          }
          await setInviteLogin(data).then((res: any) => {
            if (res.result === 'false') {
              this.$message({
                message: `${res.message}`,
                type: 'error',
              })
            } else {
              this.$message({
                message: 'Successful transfer!',
                type: 'success',
              })
              this.back()
            }
            this.loading = false
            this.flagStr()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }

  private async init() {
    await this.getList()
  }

  mounted() {
    this.payBankForm.msisdn = this.info.account_no
    this.init()
  }
}
